export default {
    env: 'prod'
}